// @ts-nocheck
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { DynamicFormComponent } from '../../dynamic-form.component';
import { FormTemplateService } from './form-template.service';

@Component({
  selector: 'lbca-form-template',
  templateUrl: './form-template.component.html',
  styleUrl: './form-template.component.scss',
  imports: [DynamicFormComponent, IconComponent],
})
export class FormTemplateComponent {
  loadForm = false;
  formTemplate;

  formState = true;

  dataAttr;
  auxEntity;

  dataInstanceId;

  dataForm;

  private dataRef;

  constructor(private dynamicFormService: FormTemplateService) {}
  public flowId;
  @Input('flowId') set flow(id) {
    this.flowId = id;
  }

  @Output('saveDataRef') saveDataRefEmmiter = new EventEmitter();

  @Output('controllCloud') controllCloudEmmiter = new EventEmitter();
  @Output('saveData') saveDataEmmiter = new EventEmitter();

  debouceModuleData;

  @Input('moduleDataRef')
  set dataRefId(id) {
    clearTimeout(this.debouceModuleData);
    this.debouceModuleData = setTimeout(() => {
      const { dataUrl, templateId } = this.auxEntity;
      if (!id) {
        const params = {
          templateId,
        };

        this.dynamicFormService.postDinamicUrl(dataUrl, {}, params).subscribe((resp: any) => {
          const id = resp.id;
          this.getFormData(id, dataUrl);
          this.saveDataRefEmmiter.emit(id);
        });
      } else {
        this.getFormData(id, dataUrl);
      }
    }, 1200);
  }

  public initialized: boolean = false;
  @Input('initialized')
  set initializedValue(initialized: boolean) {
    this.initialized = initialized;
  }

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  @Input('configuration')
  set propriets(config) {
    this.auxEntity = config.auxEntity;

    const { templateUrl, templateId } = config.auxEntity;
    this.getTemplate(templateUrl, templateId);
  }

  @Input('entityData')
  set dataAttrs(dataAttrs) {
    this.dataAttr = dataAttrs;
  }

  public getTemplate(templateUrl, templateId) {
    this.dynamicFormService.getDinamicUrl(templateUrl, { templateId }).subscribe(
      (resp) => {
        this.loadForm = true;
        this.formTemplate = resp;
      },
      () => {},
    );
  }

  public openChildFormState(state) {
    this.formState = state;
  }

  public saveData(event) {
    // this.saveDataEmmiter.emit(event);
  }

  private getFormData(id, dataUrl) {
    this.dataInstanceId = id;
    const keys: string[] = [];

    this.formTemplate.subforms.forEach((subform) => {
      subform.fields.forEach((row) => {
        row.forEach((field) => {
          keys.push(field?.entityKey);
        });
      });
    });

    const ids = JSON.stringify([id]);

    const paramns = {
      ids,
      returnFields: JSON.stringify(keys),
    };

    this.dynamicFormService.getDinamicUrl(dataUrl, paramns).subscribe((resp) => {
      this.dataForm = { ...resp?.[0] };
      setTimeout(() => (this.recoveryDataRun = false), 50);
    });
  }

  childrenFormData;
  debounceTime;

  public setChildrenFormData(struct) {
    const payload = [];
    for (const id in struct) {
      for (const field in struct[id].fields) {
        const value = struct[id].fields[field].value;
        payload[field] = value;
      }
    }
    this.childrenFormData = Object.assign({}, payload);

    clearTimeout(this.debounceTime);

    if (this.dataInstanceId) {
      this.debounceTime = setTimeout(() => {
        (this.saveForm(), 500);
      });
    }
  }

  recoveryDataRun = true;

  public saveForm() {
    this.controllCloudEmmiter.emit('saving');
    if (this.recoveryDataRun) return;
    const { dataUrl, templateId } = this.auxEntity;
    this.childrenFormData['id'] = this.dataInstanceId;
    this.dynamicFormService.putDinamicUrl(dataUrl, this.childrenFormData, { templateId }).subscribe(
      (response) => {
        this.controllCloudEmmiter.emit('saved');
      },
      (error) => {
        this.controllCloudEmmiter.emit('error');
      },
    );
  }
}
